import { Chip } from "@mui/material";
import { colors } from "../../theme";
import { getRisk, RiskLevel } from "../../utils/duplicateAudit";

const RISK_COLORS: Record<RiskLevel, string> = {
  Critical: colors.mui.error,
  High: colors.mui.warning,
  Medium: "info.main",
  Low: colors.mui.success,
};

export default function RiskBadge({ score }: { score: number }) {
  const risk = getRisk(score);
  return (
    <Chip
      label={risk}
      size="small"
      sx={{
        bgcolor: RISK_COLORS[risk],
        color: "common.white",
        fontWeight: 700,
      }}
    />
  );
}
